export const counsellorData = {
    name: 'Demo School',
    comfortableEmotions: 4000,
    uncomfortableEmotions: 6000,
    yearsList: [
        {
            year: 'Year1',
            classes: [
                { className: 'Class 1-a', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 1-b', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 1-c', comfortable: 4000, uncomfortable: 6000 },
            ],
        },
        {
            year: 'Year2',
            classes: [
                { className: 'Class 2-a', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 2-b', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 2-c', comfortable: 4000, uncomfortable: 6000 },
            ],
        },
        {
            year: 'Year3',
            classes: [
                { className: 'Class 3-a', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 3-b', comfortable: 4000, uncomfortable: 6000 },
                { className: 'Class 3-c', comfortable: 4000, uncomfortable: 6000 },
            ],
        },
    ],
}
export const counsellorWellbeingData = {
    name: 'Demo School',
    comfortable: 120,
    uncomfortable: 130,
    yearsList: [
        {
            name: '1',
            comfortable: 165,
            uncomfortable: 2,
            classes: [
                { name: 'Class 1-a', comfortable: 34, uncomfortable: 44 },
                { name: 'Class 1-b', comfortable: 22, uncomfortable: 43 },
                { name: 'Class 1-c', comfortable: 0, uncomfortable: 56 },
            ],
        },
        {
            name: '2',
            comfortable: 200,
            uncomfortable: 230,
            classes: [
                { name: 'Class 1-a', comfortable: 34, uncomfortable: 44 },
                { name: 'Class 1-b', comfortable: 22, uncomfortable: 43 },
                { name: 'Class 1-c', comfortable: 12, uncomfortable: 56 },
            ],
        },
        {
            name: '3',
            comfortable: 360,
            uncomfortable: 234,
            classes: [
                { name: 'Class 3-a', comfortable: 76, uncomfortable: 55 },
                { name: 'Class 3-b', comfortable: 45, uncomfortable: 32 },
                { name: 'Class 3-c', comfortable: 34, uncomfortable: 32 },
            ],
        },
    ],
}
